import { api } from "./api";

const hex = (buf) => Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");

export async function solveChallenge() {
  const { data } = await api.get("/growth/challenge");
  const enc = new TextEncoder();
  for (let counter = 0; counter < 5_000_000; counter++) {
    const digest = hex(await crypto.subtle.digest("SHA-256", enc.encode(`${data.nonce}:${counter}`)));
    if (digest.startsWith(data.prefix)) return { nonce: data.nonce, exp: data.exp, sig: data.sig, counter: String(counter) };
  }
  throw new Error("challenge unsolved");
}
